<!--  For some reason the not found component will not pull correctly for this.  Temporary work around.  -->
@if (+auth.token.payload.PermissionLevel < 7) {
  We're sorry -- the page you're trying to visit either could not be found or is not available to you at this time. Please use the home icon to return to MyKE.
}

@if (+auth.token.payload.PermissionLevel == 7) {
  <div class="row styleguide">
    <div class="col-12">
      <h1>Myke Student Style Guide</h1>
      <small>
        Notes: Brackets [ ] indicate element i.e. [button].btn-primary translates to
        <code>&lt;button class="btn-primary"&gt;</code>
      </small>
      <br /><br />
    </div>
    <div class="tab-content col-12" id="nav-tabContent">
      <div class="tab-pane fade show active" id="nav-default" role="tabpanel" aria-labelledby="nav-default-tab">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <h2>Typography</h2>
                <br />
                <h1>Header 1</h1><hr />
                <h2>Header 2</h2><hr />
                <h3>Header 3</h3><hr />
                <h4>Header 4</h4><hr />
                <h5>Header 5</h5><hr />
                <h6>Header 6</h6>
                <hr />
                <p>
                  This is an undecorated paragraph. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut nec vehicula purus. Integer et magna egestas lectus lacinia efficitur. Mauris tortor magna, vehicula non lorem eget, consequat euismod nisl.
                </p>
                <hr />
                <a href="#">This is a general link</a><hr />
                <a href="#" class="instructor">This is a link to email an instructor</a> [a].instructor<hr />
                <code>&lt;small&gt;</code><small>Small</small><code>&lt;/small&gt;</code> -
                <code>&lt;small&gt;</code><small><a href="#">This is a small link</a></small><code>&lt;/small&gt;</code><hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h2>Color</h2>
                <div class="row">
                  <div class="col-2">
                    <span class="dot primary-blue-dot"></span><br />
                    <strong>Primary Blue</strong><br />
                    #80C0EA
                  </div>
                  <div class="col-2">
                    <span class="dot link-blue-dot"></span><br />
                    <strong>Link Blue</strong><br />
                    #007FAE
                  </div>
                  <div class="col-2">
                    <span class="dot alert-pink-dot"></span><br />
                    <strong>Alert</strong><br />
                    #F8D7DA
                  </div>
                  <div class="col-2">
                    <span class="dot nav-gray-dot"></span><br />
                    <strong>Navigation Background</strong><br />
                    #F5F5F5
                  </div>
                  <div class="col-2">
                    <span class="dot font-dot"></span><br />
                    <strong>Font</strong><br />
                    #212529
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="row">
              <h2>Buttons</h2>
              <div class="col-12 buttons">
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-primary">.btn.btn-primary</button>
                  </div>
                  <div class="col-8">
                    Used as the primary button for action.
                    Profile, Catalog, Facilities, Biobooks, People Search
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-outline-primary">.btn.btn-outline-primary</button>
                  </div>
                  <div class="col-8">
                    Used alongside the primary button as a reset button.
                    Also used as an unselected button within a list of other selections as on the catalog page.
                    Login, Catalog
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-success">.btn.btn-success</button>
                  </div>
                  <div class="col-8">
                    Used for positive actions. Add Section, Add Bid, Parking Add Person
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-outline-secondary">.btn.btn-outline-secondary</button>
                  </div>
                  <div class="col-8">
                    Used primarily as cancellation.
                    People (email or group), Catalog Filters (days and terms), Cancel Delete Bid, Cancel Confirm Bid,
                    Confirm Navigate Away Modal, Cancel Abandon Drop, Events Cancel, Issue Cancel, Parking Cancel
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-danger">.btn.btn-danger</button>
                  </div>
                  <div class="col-8">
                    Used for removing something, or a warning before doing something that can't be undone.
                    Remove Bid, Discard Lost Bid, Abandon Section, Abandon Section Confirm Modal, Bid Delete Confirm Modal,
                    Drop Section, Abandon Section, Parking Remove Person
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-warning">.btn.btn-warning</button>
                  </div>
                  <div class="col-8">
                    Session Expired
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-link">.btn.btn-link</button>
                  </div>
                  <div class="col-8">
                    These are buttons styles to look like more like links. Mainly used in the widget settings interface, and Announcements
                    Dismiss button within the content.
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn btn-explain">.btn.btn-explain</button>
                  </div>
                  <div class="col-8">
                    Waitlist Explain More (may be removed or replaced with .btn-link)
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <button class="btn-account d-none d-md-flex" type="button" ngbDropdownToggle="" aria-haspopup="true" aria-expanded="false">
                      <span class="account-summary pr-lg-4 d-none d-lg-block">
                        <span class="account-name">Sam Sawyer</span>
                        <span class="account-description ng-star-inserted">Applications Analyst, Application Dev.</span>
                      </span>
                      <span class="user-avatar">
                        <img src="assets/images/mstile-70x70.png" alt="User Photo" />
                      </span>
                    </button>
                  </div>
                  <div class="col-8">
                    .btn-account - Used for the top right profile dropdown button
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h2>Forms</h2>
                <form>
                  [div].form-group
                  <div class="row form-group">
                    <label class="col-sm-2 col-form-label" for="LinkedIn">[label].col-form-label</label>
                    <div class="col-sm-10">
                      <div>
                        <div>
                          <input class="form-control" type="text" id="LinkedIn" maxlength="65535" placeholder="[input].form-control">
                        </div>
                      </div>
                    </div>
                    <label class="mb-0 col-sm-2 col-form-label-sm" for="academicYearSelect">[label]col-form-label-sm</label>
                    <div class="col-sm-10">
                      <select class="form-control form-control-sm mb-1" id="academicYearSelect" name="AcademicYear">
                        <option value="2021" class="ng-star-inserted"> [select].form-control-sm </option>
                        <option value="2020" class="ng-star-inserted"> 2020 / 2021 </option>
                        <option value="2019" class="ng-star-inserted"> 2019 / 2020 </option>
                      </select>
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit">
                    Save
                  </button>
                </form>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h3>Tabs</h3>
                <div class="page-inner">
                  <div class="card ng-star-inserted">
                    <div class="card-header">
                      .nav.nav-tabs.card-header-tabs
                      <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item ng-star-inserted">
                          <a aria-controls="searchallpeople" aria-selected="true" class="nav-link active" data-toggle="tab" href="#searchallpeople" role="tab">Tab 1</a>
                        </li>
                        <li class="nav-item ng-star-inserted">
                          <a aria-controls="searchallpeople" aria-selected="true" class="nav-link" data-toggle="tab" href="#searchallpeople" role="tab">[li].nav-item [a].nav-link</a>
                        </li>
                        <li class="nav-item ng-star-inserted">
                          <a aria-controls="searchallpeople" aria-selected="true" class="nav-link" data-toggle="tab" href="#searchallpeople" role="tab">Tab 3</a>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body">
                      .card-body
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="row">
              <h2>Badges</h2>
              <div class="col-12 buttons">
                <div class="row">
                  <div class="col-2">
                    <button class="badge badge-pill badge-warning">6 ToDos</button>
                  </div>
                  <div class="col-10">
                    .badge.badge-pill.badge-warning -
                    Used in My Courses opens modals to show todos from Canvas.
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <span class="badge badge-light">1Y</span> <br />
                    <span class="badge badge-dark">2Y</span>
                  </div>
                  <div class="col-10">
                    .badge.badge-light & .badge.badge-dark -
                    Student cards to denote first or second year.
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <span class="badge badge-primary">34</span><br />
                    <span class="badge badge-danger">10</span>
                  </div>
                  <div class="col-10">
                    .badge.badge-primary & .badge.badge-danger -
                    Widget title badges. Indicates a count of new items within the widget. Red used for announcements.
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <!-- ALERTS -->
            <div class="row">
              <div class="col-12">
                <h2>Alerts</h2>
                Top header alert: .alert alert-danger
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fas fa-clock"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert0'" [attr.aria-controls]="'collapseAlert0'">
                        <strong>Timely alert - .alert.alert-danger</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert0" [attr.aria-labelledby]="'headingAlert0'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is a <strong>timely</strong> alert</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fa-info-circle"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert1'" [attr.aria-controls]="'collapseAlert1'">
                        <strong>Info alert</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert1" [attr.aria-labelledby]="'headingAlert1'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is a <strong>info</strong> alert or we received an <strong>unexpected</strong> alert type.</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fas fa-bolt"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert2'" [attr.aria-controls]="'collapseAlert2'">
                        <strong>Adverse alert</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert2" [attr.aria-labelledby]="'headingAlert2'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is an <strong>adverse</strong> alert</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fa-fingerprint"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert3'" [attr.aria-controls]="'collapseAlert3'">
                        <strong>Crime alert</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert3" [attr.aria-labelledby]="'headingAlert3'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is a <strong>crime</strong> alert</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fa-exclamation-triangle"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert4'" [attr.aria-controls]="'collapseAlert4'">
                        <strong>Emergency alert</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert4" [attr.aria-labelledby]="'headingAlert4'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is an <strong>emergency</strong> alert</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tiles-alert">
                  <div class="card-expansion no-print" id="accordion">
                    <div class="alert alert-danger has-icon card card-expansion-item">
                      <div class="alert-icon">
                        <i class="fa fas fa-cogs"></i>
                      </div>
                      <button aria-expanded="false" class="btn d-flex justify-content-between w-100 collapsed alert-btn" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert5'" [attr.aria-controls]="'collapseAlert5'">
                        <strong>Server alert</strong>
                        <span class="collapse-indicator">
                          <i class="fa fa-fw fa-chevron-down"></i>
                        </span>
                      </button>
                      <div class="collapse" data-bs-parent="#accordion" id="collapseAlert5" [attr.aria-labelledby]="'headingAlert5'">
                        <div class="card card-alert-html" [innerHtml]="'<p>This is a <strong>server</strong> alert</p>'"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ANNOUNCEMENTS -->
                Announcements
                <div id="accordion" class="card-expansion">
                  <div class="accordion" id="accordion">
                    <!-- Primary Announcement-->
                    <div class="accordion-item mb-2">
                      <div class="accordion-header" id="heading0">
                        <header class="alert-primary alert has-icon">
                          <div class="container">
                            <div class="row d-flex justify-content-between align-items-center">
                              <div class=" alert-icon">
                                <i class="fas fa-bullhorn"></i>
                              </div>
                              <div class="col-auto">
                                <button class="accordion-button collapsed w-100 ms-1" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ann-col-0'" aria-expanded="false" [attr.aria-controls]="'ann-col-0'">
                                  <span class="announcement-title">Primary Announcement - .alert.alert-primary .announcement-title</span>
                                </button>
                              </div>
                              <div class="col-auto">
                                <button class="btn btn-sm btn-primary mt-2 me-2">
                                  <i class="fas fa-eye" aria-label="Restore" title="Restore"></i>
                                  <span class="sr-only">restore announcement</span>
                                </button>
                                <button class="btn btn-sm btn-primary mt-2">
                                  <i class="fas fa-eye-slash" aria-label="Dismiss" title="Dismiss"></i>
                                  <span class="sr-only">dismiss announcement</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </header>
                      </div>
                      <div [id]="'ann-col-0'" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading0'" data-bs-parent="#accordion">
                        <div class="accordion-body">
                          <div class="announcement-body card-body">
                            <h3 class="announcement-title-inbody">Primary Announcement</h3>
                            <span [innerHTML]="'<p>This is a <strong>standard</strong> announcement</p>'"></span>
                            <button class="btn btn-link btn-sm">Dismiss</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Warning Announcement -->
                    <div class="accordion-item mb-2">
                      <div class="accordion-header" id="heading1">
                        <header class="alert-warning alert has-icon">
                          <div class="container">
                            <div class="row d-flex justify-content-between align-items-center">
                              <div class=" alert-icon">
                                <i class="fa-solid fa-exclamation fa-xl"></i>
                              </div>
                              <div class="col-auto">
                                <button class="accordion-button collapsed w-100 ms-1" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ann-col-1'" aria-expanded="false" [attr.aria-controls]="'ann-col-1'">
                                  <span class="announcement-title">Warning Announcement - .alert.alert-warning .announcement-title</span>
                                </button>
                              </div>
                              <div class="col-auto">
                                <button class="btn btn-sm btn-primary mt-2 me-2">
                                  <i class="fas fa-eye" aria-label="Restore" title="Restore"></i>
                                  <span class="sr-only">restore announcement</span>
                                </button>
                                <button class="btn btn-sm btn-primary mt-2">
                                  <i class="fas fa-eye-slash" aria-label="Dismiss" title="Dismiss"></i>
                                  <span class="sr-only">dismiss announcement</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </header>
                      </div>
                      <div [id]="'ann-col-1'" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading1'" data-bs-parent="#accordion">
                        <div class="accordion-body">
                          <div class="announcement-body card-body">
                            <h3 class="announcement-title-inbody">Warning Announcement</h3>
                            <span [innerHTML]="'<p>This is a <strong>warning</strong> announcement</p>'"></span>
                            <button class="btn btn-link btn-sm">Dismiss</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Event Announcement -->
                    <div class="accordion-item mb-2">
                      <div class="accordion-header" id="heading2">
                        <header class="alert-unc-green alert has-icon">
                          <div class="container">
                            <div class="row d-flex justify-content-between align-items-center">
                              <div class=" alert-icon">
                                <i class="fas fa-calendar"></i>
                              </div>
                              <div class="col-auto">
                                <button class="accordion-button collapsed w-100 ms-1" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ann-col-2'" aria-expanded="false" [attr.aria-controls]="'ann-col-2'">
                                  <span class="announcement-title">Event Announcement - .alert.alert-unc-green .announcement-title</span>
                                </button>
                              </div>
                              <div class="col-auto">
                                <button class="btn btn-sm btn-primary mt-2 me-2">
                                  <i class="fas fa-eye" aria-label="Restore" title="Restore"></i>
                                  <span class="sr-only">restore announcement</span>
                                </button>
                                <button class="btn btn-sm btn-primary mt-2">
                                  <i class="fas fa-eye-slash" aria-label="Dismiss" title="Dismiss"></i>
                                  <span class="sr-only">dismiss announcement</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </header>
                      </div>
                      <div [id]="'ann-col-2'" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading2'" data-bs-parent="#accordion">
                        <div class="accordion-body">
                          <div class="announcement-body card-body">
                            <h3 class="announcement-title-inbody">Event Announcement</h3>
                            <span [innerHTML]="'<p>This is a <strong>event</strong> announcement</p>'"></span>
                            <button class="btn btn-link btn-sm">Dismiss</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h2>Icons</h2>
                <p>Icons are from <a href="http://www.fontawesome.com">Font Awesome</a>.</p>
                <p>
                  Usage: <br /><code>&lt;i class="fa-brands fa-jedi-order"&gt;&lt;/i&gt;</code>
                  &nbsp;<i class="fa-brands fa-jedi-order"></i>
                </p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 buttons">
                <h2>Date and Time</h2>
                <div class="row">
                  <div class="col-4">
                  </div>
                  <div class="col-4">
                    Example
                  </div>
                  <div class="col-4">
                    Angular
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Mini Time
                  </div>
                  <div class="col-4">
                    5:30p
                  </div>
                  <div class="col-4">
                    'h:mmaaaaa'
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Short Time
                  </div>
                  <div class="col-4">
                    5:30 PM
                  </div>
                  <div class="col-4">
                    'shortTime' or 'h:mm a'
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-4">
                    Short Date
                  </div>
                  <div class="col-4">
                    5/13/2020
                  </div>
                  <div class="col-4">
                    'shortDate' or 'M/d/yy'
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Medium Date
                  </div>
                  <div class="col-4">
                    May 13, 2020
                  </div>
                  <div class="col-4">
                    'mediumDate' or 'MMM d, y'
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Long Date
                  </div>
                  <div class="col-4">
                    Wed, May 13, 2020
                  </div>
                  <div class="col-4">
                    EEE, MMMM d, y
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-4">
                    Short DateTime
                  </div>
                  <div class="col-4">
                    5/13/2020, 5:30 PM
                  </div>
                  <div class="col-4">
                    'short' or 'M/d/yy, h:mm a'
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Medium DateTime
                  </div>
                  <div class="col-4">
                    May 13, 2020, 5:30 PM
                  </div>
                  <div class="col-4">
                    'MMM d, y, h:mm a'
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    Long DateTime
                  </div>
                  <div class="col-4">
                    Wed, May 13, 2020 5:30 PM
                  </div>
                  <div class="col-4">
                    'EEE, MMM d, y, h:mm a'
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h2>Loading</h2>
                <!-- Need to update:
                profile.component.html
                -->
                <strong>Widget loading - Displayed as the widget is loading information</strong><br />
                [div].widget-loading.text-center <br />
                &nbsp;&nbsp;[i].fas.fa-circle-notch.fa-spin
                <div class="widget-loading text-center">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </div>
                <!-- Larger - replace with widget-loading if possible -->
                <!--<div class="text-center">
                <h2>Loading Roster</h2>
                <i class="fas fa-circle-notch fa-spin fa-2x"></i>
              </div>-->
              <strong>Data loading - Displayed within page or widget when action is taken and data is being loaded</strong><br />
              [div].widget-action-loading.text-center<br />
              &nbsp;&nbsp;[div].typing<br />
              &nbsp;&nbsp;&nbsp;&nbsp;[span].dot<br />
              &nbsp;&nbsp;&nbsp;&nbsp;[span].dot<br />
              &nbsp;&nbsp;&nbsp;&nbsp;[span].dot
              <!-- Searching course catalog / tabs loading content -->
              <div class="widget-action-loading text-center">
                <div class="typing">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
